import { Dialog, DialogContent } from '@mui/material'
import ConfirmationDialog from 'components/dialogs/ConfirmationDialog'
import { t } from 'i18next'
import { useState } from 'react'
import { APP_COLOR } from 'utils/colors'

import LinkedCalendarsEditor from './LinkedCalendarsEditor'

interface LinkedCalendarsDialogProps {
  open: boolean
  setOpen: (open: boolean) => void
  initialGroupId?: string
}

export default function LinkedCalendarsDialog(
  props: LinkedCalendarsDialogProps
) {
  const [dirty, setDirty] = useState(false)
  const [showDiscardDialog, setShowDiscardDialog] = useState(false)

  const close = () => {
    if (dirty) {
      setShowDiscardDialog(true)
      return
    }

    props.setOpen(false)
  }

  return (
    <>
      <Dialog
        open={props.open}
        onClose={close}
        maxWidth={false}
        fullWidth
        PaperProps={{ className: 'linked-calendars-dialog' }}
      >
        <DialogContent sx={{ padding: 0 }}>
          {props.open && (
            <LinkedCalendarsEditor
              initialGroupId={props.initialGroupId}
              onDirtyChange={setDirty}
              withCloseButton
              closeAction={close}
            />
          )}
        </DialogContent>
      </Dialog>

      <ConfirmationDialog
        title={`${t('areYouSureCancel')}`}
        content={t('discardLinkedCalendarChanges')}
        rightButton={`${t('discard')}`}
        leftButton={`${t('cancel')}`}
        leftButtonColor={'black'}
        rightButtonColor={APP_COLOR}
        handleLeftButton={() => setShowDiscardDialog(false)}
        handleClose={() => setShowDiscardDialog(false)}
        handleRightButton={() => {
          setShowDiscardDialog(false)
          setDirty(false)
          props.setOpen(false)
        }}
        open={showDiscardDialog}
      />
    </>
  )
}
